export enum UseCardMethod {
  Use,
  Pay,
}
